import { useContext, useEffect, useMemo } from "react";

import { FlightAPIContext } from "contexts/flight_api_context";
import { ForumAPIContext } from "contexts/forum_api_context";
import { PresenceController } from "controllers/presence_controller";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { useUserProperties } from "hooks/use_user_properties";
import { Settings } from "settings";
import { localSelectors } from "store/index";

function PresenceTask() {
  const dispatch = useAppDispatch();
  const forumAPI = useContext(ForumAPIContext);
  const flightAPI = useContext(FlightAPIContext);
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const { class_user_id } = useUserProperties(currentUserId, ["class_user_id"]) || {};

  const presenceController = useMemo(
    () => class_user_id && new PresenceController(class_user_id, flightAPI, dispatch, forumAPI),
    [dispatch, class_user_id, flightAPI, forumAPI],
  );

  useEffect(() => {
    if (!presenceController) return;
    const interval = setInterval(() => {
      presenceController.updatePresence();
    }, Settings.PRESENCE_CHECK_IN_INTERVAL);
    return () => clearInterval(interval);
  }, [presenceController]);

  return null;
}

export { PresenceTask };
